import React from "react";
import Accordion from "@material-ui/core/Accordion";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import { Grid, Link } from "@material-ui/core/";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import { Divider } from "@material-ui/core";
import "./login.css";
import Checkbox, { CheckboxProps } from "@material-ui/core/Checkbox";
import { useHistory } from "react-router-dom";
import { UserInfo } from "node:os";


async function postData(url: string, data = {}): Promise<any> {
  // Default options are marked with *
  const response = await fetch(url, {
    method: "POST", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "same-origin", // include, *same-origin, omit
    headers: {
      "Content-Type": "application/json",
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: "follow", // manual, *follow, error
    referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    body: JSON.stringify(data), // body data type must match "Content-Type" header
  });
  if (response.ok) {
    return response.json(); // parses JSON response into native JavaScript objects
  } else {
    const text = (await response.text()).valueOf();
    throw new Error(text);
  }
}


interface IProps {
  setAbout: React.Dispatch<React.SetStateAction<boolean>>;
  setLoggedIn: React.Dispatch<React.SetStateAction<UserDto>>;
}
export const LoginPage: React.FC<IProps> = (props: IProps) => {
  const history = useHistory();
  // create state variables for each input
  const [organisation, setOrganisation] = React.useState<string>("");
  const [contact, setContact] = React.useState<string>("");
  const [email, setEmail] = React.useState<string>("");
  const [password, setPassword] = React.useState<string>("");
  const [passwordLogin, setPasswordLogin] = React.useState<string>("");

  const [emailLogin, setEmailLogin] = React.useState<string>("");
  const [checked, setChecked] = React.useState<boolean>(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };
  function postLogin(){
    postData("https://greencityapi-new.absolarlab.com/api/Auth/login",
    {
      username: emailLogin,
      password: passwordLogin,
      city_council_id: 0
    }
    ).then((userInfo: UserDto)=>{
      props.setLoggedIn(userInfo);
      history.push("/home");
    }).catch((e)=>{
      alert("Unable to login, please check username and password");
    })
  }
  function postSignUp(){
    if(password !== "" && email !== "" && checked && organisation !== "" && contact !== ""){
      postData("https://greencityapi-new.absolarlab.com/api/Auth/new",
      {
        username: email,
        password: password,
        city_council_id: 0,
        organisation: organisation,
        pointOfContact: contact
      }
      ).then((userInfo: UserDto)=>{
        props.setLoggedIn(userInfo);
        history.push("/home");
      }).catch((e)=>{
        alert("Unable to sign up, please check you've filled all the required fields");
      })
    }else{
      alert("Unable to sign up, please check you've filled all the required fields");
    }
    
  }
  return (
    <div style={{ paddingBottom: 100 }}>
      <h2>Log in for the Green City Performance Tracker</h2>
      <Grid
        container
        direction="row"
        spacing={1}
        justify="space-between"
        style={{
          marginTop: 10,
          marginBottom: 10,
          width: "100%",
          marginLeft: 0,
        }}
      >
        <Grid
          item
          xs={6}
          style={{
            textAlign: "center",
            color: "white",
            borderBottomStyle: "solid",
          }}
        >
          <Card className="card" variant="outlined">
            <CardContent>
              <h2 className="subTitle">Register</h2>
              {/* <Divider className="divider" /> */}
              <form className="root">
                <TextField
                  className="textField"
                  label="Organisation"
                  variant="outlined"
                  required
                  value={organisation}
                  onChange={(e) => setOrganisation(e.target.value)}
                />

                <TextField
                  className="textField"
                  label="Point of contact"
                  variant="outlined"
                  required
                  value={contact}
                  onChange={(e) => setContact(e.target.value)}
                />
                <TextField
                  className="textField"
                  label="Email address"
                  variant="outlined"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <TextField
                  className="textField"
                  label="Password"
                  variant="outlined"
                  type="password"
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <div style={{ width: "100%" }}>
                  <Checkbox
                    className="checkBox"
                    checked={checked}
                    onChange={handleChange}
                    name="checkedA"
                    color="primary"
                  />
                  <p
                    style={{
                      // color: "white",
                      paddingBottom: "10px",
                      float: "left",
                      WebkitTextStroke: "0.05px black",
                      marginTop: "10px",
                    }}
                  >
                    I accept the <a href="">privacy policy</a>.
                  </p>
                </div>
              </form>
              {/* <Divider className="divider" /> */}
            </CardContent>
            <CardActions>
              <Button disabled={!(password !== "" && email !== "" && checked && organisation !== "" && contact !== "")} onClick={()=>{postSignUp()}} className="button">Register</Button>
            </CardActions>
          </Card>
        </Grid>
        <Grid
          item
          xs={6}
          style={{
            textAlign: "center",
            color: "white",
            borderBottomStyle: "solid",
          }}
        >
          <Card className="card" variant="outlined">
            <CardContent>
              <h2 className="subTitle">Login</h2>
              {/* <Divider className="divider" /> */}
              <form className="root">
                <TextField
                  className="textField"
                  label="Email address"
                  variant="outlined"
                  type="email"
                  required
                  value={emailLogin}
                  onChange={(e) => setEmailLogin(e.target.value)}
                />
                <TextField
                  className="textField"
                  label="Password"
                  variant="outlined"
                  type="password"
                  required
                  value={passwordLogin}
                  onChange={(e) => setPasswordLogin(e.target.value)}
                />
              </form>
              {/* <Divider className="divider" /> */}
            </CardContent>
            <CardActions>
              <Button
                onClick={() => {
                  postLogin();
                }}
                className="button"
              >
                Sign in
              </Button>
            </CardActions>
          </Card>
        </Grid>
      </Grid>
      <br></br>
      {/* <Divider className="divider" /> */}

      <h2>Guide</h2>
      <p>
        All the guides are available to download, either as individual documents
        or as a complete file with templates available to participants upon
        registration.
      </p>
      <h2>Guide Downloads</h2>
      <Grid
        container
        direction="row"
        spacing={0}
        justify="space-between"
        style={{
          marginTop: 10,
          marginBottom: 10,
          width: "100%",
          marginLeft: 0,
        }}
      >
        <Grid
          item
          xs={2}
          style={{
            textAlign: "center",
            color: "white",
            borderBottomStyle: "solid",
          }}
        >
          <Button className="button2">Energy</Button>
        </Grid>
        <Grid
          item
          xs={2}
          style={{
            textAlign: "center",
            color: "white",
            borderBottomStyle: "solid",
          }}
        >
          <Button className="button2">Clean Air</Button>
        </Grid>
        <Grid
          item
          xs={2}
          style={{
            textAlign: "center",
            color: "white",
            borderBottomStyle: "solid",
          }}
        >
          <Button className="button2">Environment</Button>
        </Grid>
        <Grid
          item
          xs={2}
          style={{
            textAlign: "center",
            color: "white",
            borderBottomStyle: "solid",
          }}
        >
          <Button className="button2">Waste</Button>
        </Grid>
        <Grid
          item
          xs={2}
          style={{
            textAlign: "center",
            color: "white",
            borderBottomStyle: "solid",
          }}
        >
          <Button className="button2">Travel</Button>
        </Grid>
      </Grid>
      <br></br>
      <a href="">Complete guide document</a>

      <br></br>

      <p>
        If you have any questions about the Green City Charter Tracker please
        contact{" "}
        <a href="mailto:p.a.d.turner@soton.ac.uk">p.a.d.turner@soton.ac.uk</a>.{" "}
      </p>

      <p>
        If you have any questions about the Green City Charter please contact
        Southampton City Council directly at{" "}
        <a href="mailto:p.a.d.turner@soton.ac.uk">
          greencity@southampton.gov.uk
        </a>
        .
      </p>
      <br></br>
      <br></br>
      <Link
        onClick={() => {
          history.push("/about");
        }}
        style={{ color: "#44b8a8", fontWeight: "bolder", marginBottom: 50 }}
      >
        Click here to return to the GCC Homepage
      </Link>
    </div>
  );
};
